import { render } from "./EditReportingMethod.vue?vue&type=template&id=2d82143b"
import script from "./EditReportingMethod.vue?vue&type=script&lang=js"
export * from "./EditReportingMethod.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__